import { canWithAction } from "../services/auth"
export default {
  mounted(el: HTMLElement, binding: any) {
    const [code, action] = binding.value
    if (code && !canWithAction(code, action)) {
      el.setAttribute("disabled", "true")
      el.classList.add("va-disabled", "opacity-50", "pointer-events-none")
    }
  },
  updated(el: HTMLElement, binding: any) {
    const [code, action] = binding.value
    if (code && !canWithAction(code, action)) {
      el.setAttribute("disabled", "true")
      el.classList.add("va-disabled", "opacity-50", "pointer-events-none")
    } else {
      el.removeAttribute("disabled")
      el.classList.remove("va-disabled", "opacity-50", "pointer-events-none")
    }
  },
}
